import NAME from "./constants";

export const OPEN_PROGRESS = NAME + "/OPEN_PROGRESS";
export const UPDATE_PROGRESS = NAME + "/UPDATE_PROGRESS";
export const CLOSE_PROGRESS = NAME + "/CLOSE_PROGRESS";
